import { Component } from '@angular/core';

@Component({
  templateUrl: './progress-spinner.component.html',
  styleUrls: ['./progress-spinner.component.scss'],
  standalone: false,
})
export class ProgressSpinnerComponent {
  messageIndex: number = 1;
  LOADING_MESSAGE_INDEX = 'load_message_index'

  constructor() {
    let storageIndex = sessionStorage.getItem(this.LOADING_MESSAGE_INDEX);
    if (storageIndex) {
      if (+storageIndex > 10 || +storageIndex < 1) {
        this.messageIndex = 1;
      } else {
        this.messageIndex = +storageIndex;
      }
    }
    if (this.messageIndex === 10) {
      sessionStorage.setItem(this.LOADING_MESSAGE_INDEX, 1 + '');
    } else {
      sessionStorage.setItem(this.LOADING_MESSAGE_INDEX, this.messageIndex + 1 + '');
    }
  }
}

